module.exports = __webpack_public_path__ + "static/media/lock-closed.7d6451e3.svg";